import { ShopperAgentMessageStep } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { useTranslation } from "@redotech/redo-i18n";
import MessageAiIcon from "@redotech/redo-icons/message-chat-circle.svg";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { Handle, Position } from "@xyflow/react";
import { PartialWithRequiredType } from "../steps";
import { shopperAgentMessageChannelLabel } from "../steps/shopper-agent-message-channel-state";
import { BaseNode } from "./base-node";
import * as NodeCSS from "./node.module.css";

export interface ShopperAgentMessageNodeData {
  deleteElements: (id: string) => void;
  step: PartialWithRequiredType<ShopperAgentMessageStep>;
}

export function ShopperAgentMessageNode(data: {
  id: string;
  data: ShopperAgentMessageNodeData;
  selected?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <>
      <Handle position={Position.Top} type="target" />
      <BaseNode
        disabled={data.data.step.disabled}
        icon={
          <RedoFeaturedIcon color="success" Icon={MessageAiIcon} size="xs" />
        }
        onDelete={() => data.data.deleteElements(data.id)}
        selected={data.selected}
        step={data.data.step}
        title={t("Start Agent Conversation")}
      >
        <Flex className={NodeCSS.fullWidth} dir="column" justify="flex-start">
          <Text className={NodeCSS.clampedValueText}>
            {shopperAgentMessageChannelLabel(data.data.step.channel)}
          </Text>
        </Flex>
      </BaseNode>
      <Handle position={Position.Bottom} type="source" />
    </>
  );
}
